export default "__VITE_ASSET__9FTtaQOy__"